/* eslint-disable no-useless-concat */
import { ApexOptions } from "apexcharts";
import { CustomApexOptions, CustomerCardDataProps, OnlineOrderCardTypes } from "../../../Types/DashboardsType";

//charts
export const onlineOptions = {
    series: [
        {
            name: "Activity",
            data: [42, 44, 55, 66, 55, 86, 52, 44, 44, 66, 55, 86, 52, 44, 44],
        },
    ],
    chart: {
        height: 130,
        type: "bar",
        toolbar: {
            show: false,
        },
        sparkline: {
            enabled: true,
        },
    },
    plotOptions: {
        bar: {
            distributed: true,
            borderRadius: 3,
            columnWidth: "40%",
        },
    },
    dataLabels: {
        enabled: false,
    },
    grid: {
        show: false,
    },
    xaxis: {
        labels: {
            show: false
        },
    },
    legend: {
        show: false,
    },
    yaxis: {
        labels: {
            show: false
        },
    },
    colors: ['#008dab33', '#008dab33', '#008dab33', '#008dab33', '#008dab33', "#008dab", '#008dab33', '#008dab33', '#008dab33', '#008dab33', '#008dab33', '#008dab33', '#008dab33', '#008dab33', '#008dab33'],
};

export const offlineOptions = {
    series: [{
        name: "Desktops",
        data: [50, 50, 50, 25, 25, 25, 2, 2, 2, 25, 25, 25, 62, 62, 62, 35, 35, 35, 66, 66],
    }],
    chart: {
        type: 'area',
        offsetY: 30,
        height: 172,
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false,
        },
        dropShadow: {
            enabled: true,
            top: 5,
            left: 0,
            blur: 2,
            color: "#e87f24",
            opacity: 0.2,
        },
    },
    colors: ["#e87f24"],
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0.1,
            stops: [0, 90, 100]
        }
    },
    dataLabels: {
        enabled: false
    },
    grid: {
        show: false,
    },
    xaxis: {
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
    },
    stroke: {
        curve: 'straight',
        width: 2,
    },
    markers: {
        discrete: [{
            seriesIndex: 0,
            dataPointIndex: 12,
            fillColor: "#e87f24",
            strokeColor: '#fff',
            size: 5,
            shape: "circle"
        }],
    },
    responsive: [{
        breakpoint: 1661,
        options: {
            chart: {
                height: 140
            },
        },
    }
    ],
};

//datas
export const onlineOrderCardData: OnlineOrderCardTypes[] = [
    {
        id: 1,
        colClass: 'col-xl-30',
        headerClass: 'pb-0',
        color: 'primary',
        icon: 'basket',
        arrowColor: 'danger',
        percent: '-6.3',
        text: 'Online Order',
        rate: '16,2873',
        chart: {
            ...onlineOptions,
            series: onlineOptions.series,
            height: onlineOptions.chart?.height
        },
    },
    {
        id: 2,
        colClass: 'col-xl-33 offline-card',
        headerClass: 'offline-order',
        color: 'secondary',
        icon: 'delivery',
        arrowColor: 'success',
        percent: '+8.3',
        text: 'Offline Order',
        rate: '62,5461',
        chart: {
            ...offlineOptions,
            series: offlineOptions.series,
            height: offlineOptions.chart?.height
        },
        chartClass: 'offline-chart'
    },
]

export const customerCardData: CustomerCardDataProps[] = [
    {
        id: 1,
        divClass: 'col-xl-12 col-lg-12 col-md-12 col-sm-6',
        color: 'primary',
        title: 'Customers',
        rate: '1.485',
        icon: 'male',
        percent: 4.6
    },
    {
        id: 2,
        divClass: 'col-xl-12 col-lg-12 col-md-12 col-sm-6',
        bodyClass: 'money',
        color: 'secondary',
        title: 'Revenue',
        rate: '$5.873',
        icon: 'money',
        percent: 3.10
    },
];

export const webCardData = [
    {
        id: 1,
        md: 6,
        color: 'primary',
        icon: 'improvement',
        title: 'Web & mobile app',
        text: 'Dribble Presentation',
        comment: [
            { id: 1, icon: 'calendar', spanText: 'June 18,2023' },
            { id: 2, icon: 'message', spanText: '18' },
            { id: 3, icon: 'link', spanText: '08' },
        ],
        customers: [
            { id: 1, image: '1.png' },
            { id: 2, image: '2.png' },
            { id: 3, image: '3.png' },
        ],
        progressValue: 70,
    },
    {
        id: 2,
        md: 6,
        divClass: 'nft-card',
        color: 'success',
        icon: 'NFT',
        title: 'NFT website design',
        text: 'Pinterest Promotion',
        comment: [
            { id: 1, icon: 'calendar', spanText: 'June 15,2023' },
            { id: 2, icon: 'message', spanText: '20' },
            { id: 3, icon: 'link', spanText: '10' },
        ],
        customers: [
            { id: 1, image: '8.png' },
            { id: 2, image: '4.png' },
            { id: 3, image: '7.png' },
        ],
        progressValue: 60,
    },
    {
        id: 3,
        md: 12,
        divClass: 'twitter-card',
        color: 'danger',
        icon: 'management',
        title: 'Project dashboard',
        text: 'Twitter Marketing',
        comment: [
            { id: 1, icon: 'calendar', spanText: 'June 25,2023' },
            { id: 2, icon: 'message', spanText: '30' },
            { id: 3, icon: 'link', spanText: '12' },
        ],
        customers: [
            { id: 1, image: '9.png' },
            { id: 2, image: '5.png' },
            { id: 3, image: '6.png' },
        ],
        progressValue: 50,
    },
];

export const projectOptions: CustomApexOptions = {
    series: [{
        name: 'TEAM A',
        type: 'column',
        data: [220, 0, 250, 0, 210, 0, 210, 0, 270, 0, 220, 0, 250, 0, 260, 0, 210, 0, 230]
    }, {
        name: 'TEAM B',
        type: 'area',
        data: [210, 170, 240, 160, 200, 170, 200, 150, 260, 170, 210, 170, 240, 160, 250, 140, 200, 140, 220, 220]
    }],
    chart: {
        height: 355,
        type: 'area',
        stacked: false,
        toolbar: {
            show: false,
        }
    },
    stroke: {
        width: [0, 2, 5],
        curve: 'stepline'
    },
    plotOptions: {
        bar: {
            columnWidth: '35px'
        }
    },
    colors: ['#bebebe', "#008dab"],
    dropShadow: {
        enabled: true,
        top: 5,
        left: 6,
        bottom: 5,
        blur: 2,
        color: "#008dab",
        opacity: 0.5,
    },
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0.1,
            stops: [0, 90, 100]
        }
    },
    grid: {
        show: true,
        strokeDashArray: 3,
        xaxis: {
            lines: {
                show: false,
            }
        },
        yaxis: {
            lines: {
                show: true,
            }
        },
    },
    xaxis: {
        categories: ["Jan", "", "feb", "", "Mar", "", "Apr", "", "May", "", "Jun", "", "July", "", "Aug", "", "Sep", "", "Oct", ""],
        labels: {
            style: {
                fontFamily: 'Outfit, sans-serif',
                fontWeight: 500,
                colors: '#8D8D8D',
            },
        },
    },
    dataLabels: {
        enabled: false,
    },
    yaxis: {
        labels: {
            style: {
                fontFamily: 'Outfit, sans-serif',
                fontWeight: 500,
                colors: '#8D8D8D',
            },
        },
    },
    legend: {
        show: false,
    },
    tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, }) {
            return '<div class="apex-tooltip p-2">' + '<span>' + '<span class="bg-primary">' + '</span>' + 'Project Created' + '<h3>' + '$' + series[seriesIndex][dataPointIndex] + '<h3/>' + '</span>' + '</div>';
        },
    },
    responsive: [{
        breakpoint: 1661,
        options: {
            chart: {
                height: 250
            },
        },
    },
    {
        breakpoint: 1199,
        options: {
            chart: {
                height: 350
            }
        }
    },
    ],
};

export const budgetOptions: ApexOptions = {
    series: [{
        name: "Desktops",
        data: [15, 14, 11, 20, 10, 15, 11],
    }],
    chart: {
        type: 'area',
        height: 120,
        offsetY: 10,
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false,
        },
        dropShadow: {
            enabled: true,
            top: 5,
            left: 0,
            blur: 2,
            color: "#008dab",
            opacity: 0.2,
        },
    },
    colors: ["#008dab"],
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.6,
            opacityTo: 0.2,
            stops: [0, 100, 100]
        }
    },
    dataLabels: {
        enabled: false
    },
    grid: {
        show: false,
    },
    xaxis: {
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
    },
    stroke: {
        curve: 'smooth',
        width: 2,
    },
    markers: {
        discrete: [{
            seriesIndex: 0,
            dataPointIndex: 3,
            fillColor: "#008dab",
            strokeColor: "#fff",
            size: 6,
            shape: "circle"
        },
        ],
    },
};

export const budgetCardData = [
    {
        id: 1,
        color: 'primary',
        icon: 'design',
        title: 'Design',
        price: ' 35,842.00'
    },
    {
        id: 2,
        color: 'secondary',
        icon: 'development',
        iconClass: 'ms-1',
        title: 'Development',
        price: ' 5,647.00'
    },
    {
        id: 3,
        color: 'success',
        icon: 'other',
        iconClass: 'mt-2',
        title: 'Others',
        price: ' 3,237.00'
    },
];